<template>
  <nav v-if="!breakpoint.xs" class="nav" :class="{'nav-transparent':transparent && offsetTop === 0}">
    <v-layout class="layout-wrap" fill-height>
      <v-flex class="nav-logo" align-self-center>
        <router-link class="nav-logo-link" to="/">
          <img class="nav-logo-img" src="https://qihuibao.oss-cn-beijing.aliyuncs.com/logo.png">
          <span class="text px-1">{{appName}}</span>
        </router-link>
      </v-flex>
      <v-flex align-self-center>
        <ul class="nav-list link-wrap">
          <li v-for="item in navs" :key="item.title">
            <router-link :to="item.link">{{ item.title }}</router-link>
          </li>
        </ul>
      </v-flex>
    </v-layout>
  </nav>
  <v-navigation-drawer v-else app class="m-bar-menu" v-model="drawer">
    <v-list dense>
      <v-list-tile v-for="item in navs" :key="item.title">
        <v-list-tile-content>
          <v-list-tile-title>
            <router-link :to="item.link" style="color: #222;">{{ item.title }}</router-link>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    value: Boolean
  },
  data() {
    return {
      appName: process.env.VUE_APP_Name,
      screenWidth: null,
      addNav: false,
      navs: [
        { title: "首页", link: "/" },
        // { title: "企业团体保障", link: "/product/index/group" },
        // { title: "员工个人保障", link: "/product/index/person" },
        // { title: "人力资源行业保障", link: "/product/index/resources" },
        { title: "保险商城", link: "/product/index/resources" },
        { title: "关于我们", link: "/about" },
        { title: "信息披露", link: "/information" },
        { title: "客户服务", link: "/service" },
        // { title: "信息公示", link: "/announcement" },
      ],
      offsetTop: 0
    };
  },
  computed: {
    drawer: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    transparent() {
      return this.$route.meta.navTransparent || false;
    }
  },
  watch:{
    screenWidth: {
      // handler: function (val, oldVal) {
      //   if (val < 960 && this.addNav === false) {
      //     this.addNav = true;
      //     this.navs.push({title: "信息披露", link: "/information"});
      //   }
      //   if (val > 960 && this.addNav === true){
      //     this.addNav = false;
      //     this.navs.pop();
      //   }
      // },
      immediate: true
    },
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.offsetTop = document.documentElement.scrollTop;
    });
    this.screenWidth = document.body.clientWidth;
    if (this.screenWidth < 960 && this.addNav === false){
      this.addNav = true;
      // this.navs.push({title: "信息披露", link: "/information"});
    }
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  }
};
</script>

<style lang="scss" scoped>
$toolbar-height: 40px;
$nav-height: 80px;
.nav {
  width: 100%;
  height: $nav-height;
  color: $font-color;
  background-color: $bg-light-color;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.04);
  position: fixed;
  top: $toolbar-height;
  z-index: 2;
  &-logo {
    display: flex;
    flex-grow: 0;
    margin-right: 5%;
    &-link {
      display: flex;
      align-items: center;
    }
    &-img {
      width: 30px;
      height: 30px;
    }
  }
  &-list {
    li {
      display: inline-block;
      margin-left: 3em;
    }
  }
}
.nav-transparent {
  background-color: transparent;
  box-shadow: none;
  .text {
    color: $light-color;
  }
  a {
    color: #d1d1d1;
    &:hover {
      color: $light-color!important;
    }
  }
  a.active,
  a.router-link-exact-active {
    color: $light-color!important;
  }
}
</style>

